import { render, staticRenderFns } from "./PayPalPaymentButton.vue?vue&type=template&id=0da288bb&"
import script from "./PayPalPaymentButton.vue?vue&type=script&lang=js&"
export * from "./PayPalPaymentButton.vue?vue&type=script&lang=js&"
import style0 from "./PayPalPaymentButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports